import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=9235eea6"
import script from "./invitation.ts?vue&type=script&lang=ts&external"
export * from "./invitation.ts?vue&type=script&lang=ts&external"
import style0 from "./invitation.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports